import { DashboardOverview } from "@/components/dashboard/DashboardOverview";

const Dashboard = () => {
  return <DashboardOverview />;
};

export default Dashboard;